<!--
 * @Descripttion: 本次专区反馈效果评价
 * @Date: 2025-07-09 14:49:13
-->
<template>
  <div>
    <component :is="cmpName" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import {
  BiTmplDetail_18_1,
  BiTmplDetail_18_2,
  BiTmplDetail_18_3,
  BiTmplDetail_18_4
} from '@/views/bi-tmpl/src/components/bi-tmpl-detail/bi-tmpl-detail-18/components/index';
import { useBiTmplDetailSteup } from '../../../store';
import { storeToRefs } from 'pinia';

const store = useBiTmplDetailSteup();
const { state } = storeToRefs(store);

const BiTmplDetail_19_s = {
  BiTmplDetail_19_1: BiTmplDetail_18_1,
  BiTmplDetail_19_2: BiTmplDetail_18_2,
  BiTmplDetail_19_3: BiTmplDetail_18_3,
  BiTmplDetail_19_4: BiTmplDetail_18_4
};
const cmpName = computed(() => {
  return BiTmplDetail_19_s['BiTmplDetail_' + state.value.activeMenu[1]];
});
</script>
<style scoped lang="scss"></style>
